/**
 * The Priorities surfaces' own constants: how they draw, and the request
 * defaults they send. The scoring thresholds live with the scorer
 * (okf-be routes/api/aiAnnotation/services/priorities/CONFIG.js) and reach
 * the UI on the response's meta (severityHigh, minNowTotal, zoneOrder).
 */
export const CONFIG = {
  // How far back the history series looks, in periods of the selected grain
  // — the span the trend charts request.
  HISTORY_MAX_PERIODS: 12,
  // How many periods with data, the selected one included, the trend spans
  // (2 = the previous period). The scorer's default; the picker's options.
  TREND_WINDOW: 2,
  TREND_WINDOW_OPTIONS: [2, 3, 6],

  // ── Presentation ─────────────────────────────────────────────────────
  // The four cards above the field: the hottest priorities + the brightest wins.
  TOP_PANEL: { alerts: 2, wins: 2 },
  FIELD_LABELS: 6,
  // The field's x-axis is a momentum INDEX where the band edge is ±1 in
  // both modes; this is how far it draws.
  // The index is drawn compressed beyond the band (see xScale.js): 1, 2, 4,
  // 8, 16 sit at equal spacing, so this cap is where a bubble finally pins
  // to the edge. Linear it was 3, and everything past it piled up there.
  FIELD_X_MAX: 16,
};

// Priority order of the zones — the ranked list sorts by this first.
export const ZONE_ORDER = ["fires", "chronic", "emerging", "resolving", "background", "fading"];
